import { render } from "./HomeProject.vue?vue&type=template&id=64ddca2b&scoped=true&ts=true"
import script from "./HomeProject.vue?vue&type=script&lang=ts"
export * from "./HomeProject.vue?vue&type=script&lang=ts"

import "./HomeProject.vue?vue&type=style&index=0&id=64ddca2b&scoped=true&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ddca2b"]])

export default __exports__